export default "__VITE_ASSET__DYNT0S4C__"